export default "__VITE_ASSET__pS3Netbj__"